import { loading, error, suggestions, filters } from '../state'
import { suggestionsService } from '../../../services/suggestions/suggestions-service'
import { fetchSuggestions } from './fetch-suggestions'
import { useAssetStore } from '@/stores'

/**
 * Öneriyi siler
 * @param {Number|String} id - Silinecek öneri ID'si
 * @returns {Promise<Boolean>} İşlem başarılı mı?
 */
export const deleteSuggestion = async (id) => {
  try {
    // Store'dan assetId'yi al - Fonksiyon içinde çağırıyoruz!
    const assetStore = useAssetStore()
    const assetId = assetStore.assetId

    loading.value = true
    error.value = null

    // AssetId parametresi ekle
    const params = { assetId }

    const response = await suggestionsService.deleteSuggestion(id, params)

    if (response.success) {
      // Öneri listesini güncelle
      await fetchSuggestions()

      // Listedeki ilgili öneriyi kaldır
      suggestions.value = suggestions.value.filter(s => s.id !== id)

      return true
    } else {
      error.value = 'Öneri silinirken bir hata oluştu'
      throw new Error('Öneri silinirken bir hata oluştu')
    }

  } catch (err) {
    console.error(`Error deleting suggestion with id ${id}:`, err)
    error.value = 'Öneri silinirken bir hata oluştu'
    throw err
  } finally {
    loading.value = false
  }
}
